<template>
  <div id="app">
    <div v-if="loading === true">
      <loading-view></loading-view>
    </div>
    <div v-else>
      <toolbar @refresh="reloadData()"></toolbar>
      <asset-list :assets="assets" @refresh="reloadData()"></asset-list>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LoadingView from "./components/Loading.vue";
import Toolbar from "./components/Toolbar.vue";
import AssetList from "./components/AssetList.vue";

export default {
  name: "App",
  components: { LoadingView, Toolbar, AssetList },
  created() {
    //validate that this domain key is valid with the backend
    this.reloadData();
  },
  data() {
    return {
      loading: false,
      title: "Submit",
      assets: [],
    };
  },
  methods: {
    reloadData: function() {
      var sidTest = this.$route.query.uid;
      if (sidTest === null || sidTest === "" || sidTest === undefined) {
        window.location.href = "https://google.com";
        this.loading = false;
      } else {
        this.loading = true;
        let validateURL = "/backend/" + sidTest + "/assets";
        axios
          .get(validateURL)
          .then((res) => {
            if (res.data) {
              console.log("this users key has been validated");
              console.log(res.data);
              this.loading = false;
              this.assets = res.data;
            }
          })
          .catch(() => {
            window.location.href = "https://google.com";
            this.loading = false;
          });
      }
    },
    didUploadFile: function(event) {
      console.log(event);
      console.log("This is a thing");
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
